export function transformMoney (money, currency) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || "EUR"}).format(money)
}